import { Box, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
}

const useStyles = createUseStyles((theme: Theme) => ({
  cardRow: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

const CardRow: FC<Props> = ({ children }) => {
  const styles = useStyles();
  return (
    <Box className={styles.cardRow} py={1} px={1.5}>
      {children}
    </Box>
  );
};

export default CardRow;
